import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { walkClaimText } from '../../../../lib/walkClaimText';
import { PowerIntentIntroStrip } from './PowerIntentIntroStrip';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const RenewableIntegrationSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const text = report.powerAnalysis?.renewableIntegration;
  return (
    <SectionShell label={label} hasData={!!text}>
      <PowerIntentIntroStrip report={report} focus="renewables" />
      {text && (
        <EditorialSubsection theme={theme} label="Integration assessment">
          {walkClaimText(text, report.references)}
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
